import appEvents from 'events/app';
import configSelectors from 'selectors/configuration';
import { DISPLAY_TYPE } from 'enums/configuration';
import executeRule from 'actions/configuration/executeRule';
import { getWithinOfficeHours, hasActiveSession, isThrottled } from 'app/modules';
import hideDefaultAndCustomWidget from 'actions/ui/hideDefaultAndCustomWidget';
import uiEvents from 'events/ui';
import updateWelcomeMessage from 'actions/session/updateWelcomeMessage';

export default function evaluateRules(dispatch, getState) {
  const state = getState();
  const matchedRule = configSelectors.getRule(state.configuration);
  const display = configSelectors.getDisplay(state.configuration);

  if (
    display === DISPLAY_TYPE.ALL_PAGES ||
    hasActiveSession(state) ||
    configSelectors.getKillswitchIsOn(state.configuration) ||
    getWithinOfficeHours(state) === false ||
    isThrottled(state)
  ) {
    // no rules applies
    return;
  }

  dispatch(uiEvents.suppress());
  if (!matchedRule) {
    if (state.ui.isMinimized) {
      dispatch(hideDefaultAndCustomWidget);
    }
    return;
  }

  const rule = matchedRule.rule;
  const key = matchedRule.key;

  dispatch(updateWelcomeMessage(rule.message));

  // display minimized widget after displayDelay which defaults to zero
  let timeoutId = setTimeout(() => {
    dispatch(executeRule);
  }, rule.displayDelay);

  let currentRule = { rule, key, timeoutId };

  /* setCurrentRule gets dispatched before executeRule since the timeout always 
  has a duration >= 0 */
  dispatch(appEvents.setCurrentRule(currentRule));
}
